module.exports = __webpack_public_path__ + "img/background-dots-lines-1.7b66284.jpg";